import { useState } from 'react'

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false)

  const toggleMenu = () => {
    setMenuOpen(!menuOpen)
  }

  return (
    <>
      {/* Menu Overlay */}
      <div
        className={`fixed inset-0 bg-black/98 z-[60] flex items-center justify-center transition-all duration-600 ${
          menuOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
        }`}
      >
        <div className="text-center px-6 w-full max-w-md">
          <nav className="mb-8">
            <a
              href="https://michaelwcoleman.com/real-estate"
              className="block text-white text-xl uppercase tracking-[0.4em] my-10 font-extralight hover:opacity-40 transition-opacity"
            >
              Luxury Real Estate
            </a>
            <a
              href="https://michaelwcoleman.com/art"
              className="block text-white text-xl uppercase tracking-[0.4em] my-10 font-extralight hover:opacity-40 transition-opacity"
            >
              The Artist
            </a>
            <a
              href="https://michaelwcoleman.com/aboutme"
              className="block text-white text-xl uppercase tracking-[0.4em] my-10 font-extralight hover:opacity-40 transition-opacity"
            >
              About Me
            </a>
            <a
              href="#"
              className="block text-white text-xl uppercase tracking-[0.4em] my-10 font-extralight hover:opacity-40 transition-opacity"
            >
              Videos
            </a>
          </nav>

          <div className="h-[1px] w-12 bg-white/20 mx-auto mb-10"></div>

          <div className="space-y-8">
            <div className="space-y-1">
              <p className="text-[10px] tracking-[0.4em] uppercase opacity-40">
                Direct Inquiries
              </p>
              <a
                href="tel:7206336182"
                className="text-xl font-light tracking-widest text-white hover:opacity-60 transition"
              >
                720.633.6182
              </a>
            </div>

            <button
              onClick={() => {
                alert('Contact form coming soon')
                toggleMenu()
              }}
              className="w-full py-4 border border-white text-white text-[11px] font-bold uppercase tracking-[0.3em] hover:bg-white hover:text-black transition-all duration-300"
            >
              Book a Consultation
            </button>
          </div>

          <p
            className="text-[9px] tracking-[0.6em] uppercase opacity-40 mt-16 cursor-pointer hover:opacity-100 transition"
            onClick={toggleMenu}
          >
            Close Menu
          </p>
        </div>
      </div>

      {/* Main Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-black/90 backdrop-blur-md border-b border-gray-900 transition-all duration-300">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="relative py-3 md:py-4 transition-all duration-300 flex justify-center">
            {/* Center: Logo */}
            <a href="/" className="z-20 block mx-auto">
              <img
                className="h-12 md:h-20 w-auto transition-all duration-300"
                src="/MCC-white.png"
                alt="Coleman Colorado Collective Logo"
              />
            </a>

            {/* Right: Mobile Menu Button */}
            <div className="flex items-center absolute right-4 md:right-8 top-1/2 transform -translate-y-1/2">
              <button onClick={toggleMenu} className="p-2 text-white hover:text-white/70 transition duration-300">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </nav>
    </>
  )
}
